<template>
  <ul class="c-list--checkup">
    <li class="c-list--checkup__item">
      <span class="c-list--checkup__label judgement">判定</span>
      <div class="c-list--checkup__content">
        <p v-if="!hasError">
          あなたのWebページで扱われているCSSはすべてキャッシュされています。
        </p>
        <p v-else>
          あなたのWebページで扱われているCSSはキャッシュされていない内容があります。
        </p>
      </div>
    </li>
    <li
      v-if="cssCacheCachedLinks.length || cssCacheUncachedLinks.length"
      class="c-list--checkup__item"
    >
      <span class="c-list--checkup__label detail">内容</span>
      <div class="c-list--checkup__content">
        <dl v-if="cssCacheCachedLinks.length">
          <dt>キャッシュされているCSSのリンク</dt>
          <dd>
            <ul class="c-list--disc">
              <li v-for="(item, index) in cssCacheCachedLinks" :key="index">
                {{ item }}
              </li>
            </ul>
          </dd>
        </dl>
        <dl v-if="cssCacheUncachedLinks.length">
          <dt>キャッシュされていないCSSのリンク</dt>
          <dd>
            <ul class="c-list--disc">
              <li v-for="(item, index) in cssCacheUncachedLinks" :key="index">
                {{ item }}
              </li>
            </ul>
          </dd>
        </dl>
      </div>
    </li>
    <li v-if="hasError" class="c-list--checkup__item">
      <span class="c-list--checkup__label hint">ヒント</span>
      <div class="c-list--checkup__content">
        <p>
          HTTP要求の数を減らすために、HTTP
          Expiresヘッダーを使用して、CSSリソースまたはその他のコンテンツタイプの有効期限を設定できます。<br />.htaccessファイルに次の行を追加できます。
        </p>
        <pre class="c-text--pre"><code>&lt;IfModule mod_expires.c&gt;
  ExpiresActive on
  ExpiresByType text/css "access plus 1 month"
&lt;/IfModule&gt;</code></pre>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      required: true
    },
    hasError: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    cssCacheCachedLinks() {
      if (this.detail.link.cached) {
        return this.detail.link.cached.filter(item => item.url);
      }
      return [];
    },
    cssCacheUncachedLinks() {
      if (this.detail.link.uncached) {
        return this.detail.link.uncached.filter(item => item.url);
      }
      return [];
    }
  }
};
</script>
